if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
        readMoreButtons: '.testimonial__read-more',
        popup: '[data-testimonial-popup]',
        popupContent: '.testimonial-popup__content',
        popupClose: '[data-testimonial-popup-close]',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.tabletLargeItems = parseInt(this.dataset.tabletLargeItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      // Swiper controls are rendered *after* this element in the section HTML, so they do not
      // exist yet when connectedCallback runs. Defer init until the rest of the section is parsed.
      queueMicrotask(() => this.init());

      document.addEventListener('matchMobile', () => {
        this.init();
      });

      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }


    // ✅ CHANGED — always init slider (mobile also)
    init() {
      this.initSlider();
    }


    initSlider() {
      if (!this.section || !this.sliderWrapper) return;
      if (typeof this.sliderInstance === 'object') return;

      const nextEl = this.section.querySelector(this.selectors.nextEl);
      const prevEl = this.section.querySelector(this.selectors.prevEl);

      if (!nextEl || !prevEl) {
        this._navWaitAttempts = (this._navWaitAttempts || 0) + 1;
        if (this._navWaitAttempts > 30) return;
        requestAnimationFrame(() => this.initSlider());
        return;
      }
      this._navWaitAttempts = 0;

      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: 1, // mobile
        spaceBetween: columnGap.mobile,

        navigation: {
          nextEl,
          prevEl,
        },

        pagination: false,

        breakpoints: {
          768: {
            slidesPerView: parseInt(this.tabletItems),
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: parseInt(this.tabletLargeItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        },

        loop: true,
        threshold: 2,
      };


      this.classList.add(this.classes.swiper);

      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(
        this,
        sliderOptions
      );

      this.sliderInstance.init();

      FoxTheme.a11y.bindSliderFocusManagement(this, () => this.sliderInstance?.slider);


      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {

          if (e.detail.sectionId != this.sectionId) return;

          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);

        });
      }
    }


    destroySlider() {

      this.classList.remove(this.classes.swiper);

      this.sliderWrapper.classList.remove(
        this.classes.swiperWrapper
      );

      this.sliderWrapper.classList.add(
        this.classes.grid
      );

      if (typeof this.sliderInstance === 'object') {

        this.sliderInstance.slider.destroy();

        this.sliderInstance = false;
      }
    }
  }

  customElements.define(
    'testimonials-component',
    Testimonials
  );
}